// extracted by mini-css-extract-plugin
export default {"root":"IconShield_root__tN9Dv"};